
angular.module('bmsApp.crm.customer').factory('CustomerSvc', function ($rootScope, $q, CRUDSvc, $modal, CUSTOMER_API) {

	return {
		index: function (params) {
			return CRUDSvc.get(CUSTOMER_API.INDEX, params);
		},
		create: function (customer) {
			return CRUDSvc.post(CUSTOMER_API.CREATE, customer);
		},
		read: function (id) {
			return CRUDSvc.get(CUSTOMER_API.READ + id);
		},
		update: function (id, customer) {
			return CRUDSvc.post(CUSTOMER_API.UPDATE + id, customer);
		},
		duplicateCheck: function (customer) {
			var customerPost = {
				id: customer.id,
				lname: customer.primary_contact.lname,
				postcode: customer.primary_site.postcode
			};
			return CRUDSvc.get('api/customer/duplicate-check', customerPost);
		},
		geographicalCheck: function(customer, license) {
			var customerPost = {
				id: customer.id,
				postcode: customer.primary_site.postcode,
				licenseId: license.id
			};
			return CRUDSvc.get('api/customer/geographic-restriction-check', customerPost);
		},
		import: function (customers) {
			return CRUDSvc.post(CUSTOMER_API.IMPORT, customers);
		},
		export: function(params) {
			var newParams = angular.extend({}, params, {
				'format': 'csv'
			});
			var query = $.param(newParams);
			window.open(CUSTOMER_API.INDEX + '?' + query);
		},
		options: function (params) {
			return CRUDSvc.get(CUSTOMER_API.OPTIONS, params);
		},
		paymentTermOptions: function () {
			var deferred = $q.defer();

			// spoof response
			var response = {
				data: {
					success: true,
					message: '',
					options: [
						{
							value: 0,
							label: 'On Completion'
						},
						{
							value: 7,
							label: '7 Days'
						},
						{
							value: 14,
							label: '14 Days'
						},
						{
							value: 30,
							label: '30 Days'
						},
						{
							value: 60,
							label: '60 Days'
						},
						{
							value: 90,
							label: '90 Days'
						}
					]
				}
			};

			deferred.resolve(response);

			return deferred.promise;
		},
		upcomingAnniversaries: function () {
			return CRUDSvc.get(CUSTOMER_API.UPCOMING_ANNIVERSARIES);
		},
		activeJobs: function () {
			return CRUDSvc.get('api/customer/active-customer-jobs');
		},
		getBalance: function (id) {
			return CRUDSvc.get('api/customer/get-balance/' + id);
		},
		repeatEnquiry: function(params) {
			return CRUDSvc.post('api/customer/repeat-enquiry', params);
		},
        gdprCleansing: function(params) {
            return CRUDSvc.post(CUSTOMER_API.GDPR_CLEANSING, params);
        },
        postponeGdprCleansing: function(params) {
            return CRUDSvc.post(CUSTOMER_API.POSTPONE_GDPR_CLEANSING, params);
        },

		showRepeatEnquiryModal: function (customer) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/crm/customer/templates/RepeatEnquiryModal.html',
				controller: 'RepeatEnquiryModalCtrl',
				controllerAs: 'RepeatEnquiry',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					customer: function () {
						return angular.copy(customer);
					}
				}
			});

			modalInstance.result.then(function (result) {

			}, function () {
				// closed
			});

			return modalInstance.result;
		}
	};

}).constant('CUSTOMER_API', {
	INDEX: 'api/customer/index',
	CREATE: 'api/customer/create',
	READ: 'api/customer/read/',
	UPDATE: 'api/customer/update/',
	IMPORT: 'api/customer/import',
	OPTIONS: 'api/customer/options',
	UPCOMING_ANNIVERSARIES: 'api/customer/upcoming-anniversaries',
    GDPR_CLEANSING: 'api/customer/gdpr-cleansing',
    POSTPONE_GDPR_CLEANSING: 'api/customer/postpone-gdpr-cleansing',
});
